module.exports = __webpack_public_path__ + "img/+.da16f866.svg";